class PredictiveSearchDiscovery extends HTMLElement {
  #swiper = null;

  connectedCallback() {
    this.#initSwiper();
  }

  disconnectedCallback() {
    this.#destroySwiper();
  }

  /**
   * Initialize Swiper instance for popular terms
   */
  async #initSwiper() {
    const swiperElement = this.querySelector('[data-swiper-popular-terms]');
    if (!swiperElement) return;

    try {
      const { Swiper } = await import('@services');

      this.#swiper = new Swiper(swiperElement, {
        modules: ['FreeMode'],
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: {
          enabled: true,
          sticky: false,
        },
      });
    } catch (error) {
      console.error('Error initializing Swiper:', error);
    }
  }

  /**
   * Destroy Swiper instance
   */
  #destroySwiper() {
    if (this.#swiper && typeof this.#swiper.destroy === 'function') {
      this.#swiper.destroy(true, true);
      this.#swiper = null;
    }
  }
}

customElements.define('predictive-search-discovery', PredictiveSearchDiscovery);
